import {createAction, props} from '@ngrx/store';
import {UserDataModel} from '@core/modules/rest/user/response/user-data.model';
import {CreateUserRequestModel} from '@core/modules/rest/user/request/create-user-request.model';
import {AlterUserActiveStatusRequestModel} from '@core/modules/rest/user/request/alter-user-active-status-request.model';
import {SaveUserRolesRequestModel} from '../components/popups/edit-roles-popup/model/save-user-roles-request.model';
import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';
import {SaveEducationSettingsRequestModel} from '@core/modules/rest/user/request/save-education-settings-request.model';
import {SearchDataModel} from '@shared/model/search-data.model';
import {TextSizeEnum} from '../../display-consent/enums/text-size.enum';

export const ResetState = createAction(
    '[User] Reset state'
);

export const GetUsersByOrganization = createAction(
    '[User] Get users by organization',
    props<{ organization: string, offset: number }>()
);

export const GetUsersByOrganizationSuccess = createAction(
    '[User] Get users by organization success',
    props<{ users: UserDataModel[] }>()
);

export const GetFilteredUsersByOrganization = createAction(
    '[User] Get filtered users by organization',
    props<{ organization: string, searchData: SearchDataModel }>()
);

export const GetFilteredUsersByOrganizationSuccess = createAction(
    '[User] Get filtered users by organization success',
    props<{ users: UserDataModel[] }>()
);

export const CreateUser = createAction(
    '[User] Create user in organization',
    props<{ request: CreateUserRequestModel, executed: (done: boolean, statusCode: number, user: UserDataModel, emailInUse: boolean) => void }>()
);

export const CreateUserSuccess = createAction(
    '[User] Create user in organization success',
    props<{ newUser: UserDataModel }>()
);

export const AlterUserStatus = createAction(
    '[User] Alter user active status',
    props<{ request: AlterUserActiveStatusRequestModel }>()
);

export const AlterUserStatusSuccess = createAction(
    '[User] Alter user active status success',
    props<{ alteredUser: UserDataModel }>()
);

export const DeleteUser = createAction(
    '[User] Delete user',
    props<{ userId: string }>()
);

export const DeleteUserSuccess = createAction(
    '[User] Delete user success',
    props<{ userId: string }>()
);

export const UpdateUserRoles = createAction(
    '[User] Update user roles',
    props<{ request: SaveUserRolesRequestModel }>()
);

export const UpdateUserRolesSuccess = createAction(
    '[User] Update user roles',
    props<{ userId: string, newRoles: KeycloakApplicationRolesEnum[] }>()
);

export const SaveUserEducationSettings = createAction(
    '[User] Save user education settings',
    props<{ request: SaveEducationSettingsRequestModel, executed: () => void }>()
);

export const SaveUserEducationSettingsSuccess = createAction(
    '[User] Save user education settings success',
    props<{ updatedUser: UserDataModel }>()
);

export const UpdateUserSettingsSuccess = createAction(
    '[User] Update user basic mode success',
    props<{ userId: string, settings: string, personalSettings: string }>()
);

export const UpdateUserTextSize = createAction(
    '[User] Update user text size',
    props<{ userId: string, textSize: TextSizeEnum }>()
);

export const UpdateUserTextSizeSuccess = createAction(
    '[User] Update user text size success',
    props<{ userId: string, textSize: TextSizeEnum }>()
);

export const GetStartedConsentWithQuestions = createAction(
    '[User] Get user active consents comment number',
    props<{ userId: string, executed: (noOfQuestions: number) => void }>()
);

export const GetStartedConsentWithQuestionsSuccess = createAction(
    '[User] Get user active consents comment number success'
);

export const MergeUsersActiveConsentComments = createAction(
    '[User] Merge users active consent comments',
    props<{ userId: string }>()
);

export const MergeUsersActiveConsentCommentsSuccess = createAction(
    '[User] Merge users active consent comments success'
);
